module.exports = "/images/es_CO.svg";